import { useEffect, useState } from "react";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const steps = ["Registration", "Complete Profile", "Payment", "Issue MemberID Card"];

const CustomStepIcon = ({ completed }) => {
    return completed ? (
        <CheckCircleIcon sx={{ color: "green" }} />
    ) : (
        <CheckCircleIcon sx={{ color: "gray" }} />
    );
};

const MembershipStepper = () => {
    const [formData, setFormData] = useState({});
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        const mobile = localStorage.getItem("mobile");

        if (!mobile) {
            setError("Mobile number not found in localStorage.");
            return;
        }

        try {
            const response = await axios.get(`${API_BASE_URL}?action=myprofile&mobile=${mobile}`);

            if (response.data.status === "success" && response.data.data) {
                setFormData(response.data.data);
                console.log("Fetched Data:", response.data.data);
            } else {
                setError("Failed to fetch user data.");
            }
        } catch (error) {
            setError("Error fetching data. Please try again.");
            console.error("Fetch Error:", error);
        }
    };

    // Mandatory profile fields
    const requiredFields = [
        "ID_Proof_Type", "ID_Proof_Number", "Pan_Card", "Pan_Number",
        "Email", "Occupation", "Address", "Family_Details", "Marital_Status"
    ];

    const isProfileCompleted = requiredFields.every(field => {
        const value = formData?.[field];
        return value !== undefined && String(value).trim() !== "";
    });

    const isPaymentCompleted = formData?.Payment_Status?.toLowerCase() === "paid";
    const isIDCardGenerated = formData?.ID_Card?.toLowerCase() === "generated";

    // Determine step completion independently
    const stepsCompleted = [
        true, 
        isProfileCompleted,
        isPaymentCompleted,
        isProfileCompleted && isPaymentCompleted && isIDCardGenerated 
      ];
      

    console.log("Profile Completed:", isProfileCompleted);
    console.log("Payment Completed:", isPaymentCompleted);
    console.log("ID Card Generated:", isIDCardGenerated);
    console.log("Steps Completed:", stepsCompleted);


 

    return (
        <Box sx={{ width: "100%", my: 3 }}>
            {error && <Typography color="error" sx={{ textAlign: "center" }}>{error}</Typography>}

            <Stepper activeStep={stepsCompleted.lastIndexOf(true)} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={label} completed={stepsCompleted[index]}>
                        <StepLabel StepIconComponent={(props) => <CustomStepIcon completed={stepsCompleted[index]} {...props} />}>
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default MembershipStepper;
